export const ServiceData = [
    {
        id: 1,
        title: 'WEB DEVELOPMENT',
        image: '/img/carbon_earth.png',
        detail: `A very professional front-end web developer with enthusiasm for Full Stack Web
        Development.`
    },
    {
        id: 2,
        title: 'PIXEL PERFECT',
        image: '/img/bx_bx-image.png',
        detail: 'All my works are pixel perfect and they match design with 100% conversion.'
    },
    {
        id: 3,
        title: 'RESPONSIVENESS',
        image: '/img/bi_toggles.png',
        detail: 'All my works are responsive on all screensizes from small to extra large screensizes.'
    },
    {
        id: 4,
        title: 'MORE THAN DESIGN',
        image: '/img/bx_bx-image.png',
        detail: `I also don't just do the design part of front end, I develop using Javascript, Jquery,
        APIs and more.`
    },
    {
        id: 5,
        title: 'LEARNING CULTURE',
        image: '/img/Group.png',
        detail: `I never settle for less. I'm always looking to learn new technologies and quickly too.`
    }, {
        id: 6,
        title: 'REACT JS',
        image: '/img/bi_window.png',
        detail: 'I also come with sound knowledge and experience in Reactjs and its important plugins.'
    }
]